import { Controller, useFormContext } from "react-hook-form";
import { PaymentDepositCustomerType } from "../types";
import { Button, Input, Modal } from "components";
import { useToggle } from "utils";
import CustomerOrderDetail from "../../CustomerOrder/components/Detail";
import { useParams } from "react-router-dom";
import { TbInfoCircle } from "react-icons/tb";

export function LinkToSalesOrder(): JSX.Element {

    const { control, getValues } = useFormContext<PaymentDepositCustomerType>()
    const salesOrderId = getValues("sales_order_id");
    

    return (
        <section className="flex items-end">
            <section className="grow">
                <Controller
                    control={control}
                    name="link"
                    render={({ field }) => (
                        <Input
                            disabled
                            label="LINK TO SALES ID"
                            defaultValue={field.value}
                        />
                    )}
                />
            </section>
            <DetailSection
                sales_order_id={salesOrderId?.toString()}
            />
        </section>
    )
}

function DetailSection(props: {
    sales_order_id?: string
}) {
    const { isActive, toggle } = useToggle(false)
    const { sales_order_id } = useParams()

    return (
        <>
            <Button
                type="button"
                color="primary"
                onClick={toggle}
            >
                <TbInfoCircle />
            </Button>

            {isActive && (
                <Modal
                    isOpen
                    title="SALES ORDER DETAIL"
                    closeModal={toggle}
                >
                    <Modal.Body>
                        <CustomerOrderDetail 
                            sales_order_id={sales_order_id ? sales_order_id.toString() : props.sales_order_id!.toString()}
                        />
                    </Modal.Body>
                </Modal>
            )}
        </>
    )
}